import { useTranslation } from "react-i18next";

import { cn } from "~/lib/utils";
import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { buttonVariants } from "../ui/button";

export default function UnsavedChangesDialog({
  isOpen,
  onContinue,
  onDiscard,
}: {
  isOpen: boolean;
  onContinue: () => void;
  onDiscard: () => void;
}) {
  const { unsavedChanges, setUnsavedChanges } = useUnsavedChanges();

  const { t } = useTranslation("common");

  const handleDiscard = () => {
    if (unsavedChanges.onDiscard) {
      unsavedChanges.onDiscard();
    }
    onDiscard();
    setUnsavedChanges({ isDirty: false });
  };

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("UnsavedChanges.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("UnsavedChanges.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onContinue}>
            {t("UnsavedChanges.continue_editing")}
          </AlertDialogAction>
          <AlertDialogCancel
            className={cn(buttonVariants({ variant: "destructive" }))}
            onClick={handleDiscard}
          >
            {t("discard_changes")}
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
